// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"543ed7f6","331":"56408c32","787":"22792874"}[chunkId] + ".chunk.js";
};